export function buildActivityReportLink(reportDate, conciergeUserId) {
  const params = new URLSearchParams({ report_date: reportDate })
  if (conciergeUserId) {
    params.set("performed_by", String(conciergeUserId))
  }
  return `/activity?${params.toString()}`
}
